import logo from './logo.svg';
import './App.css';
import WeatherDashboard from './Pages/Whether';
// import WeatherDashboard from './Whether';


function App() {
  return (
    <>
      <WeatherDashboard/>
    </>
  );
}

export default App;
